"use strict";
 
define('components/form_manager',['components/ajax', 'components/form'], function(ajax, form) {
     
     var formManager = {
        init: function (formNode) {
            var self = this;
            formNode.find('button[type=submit]').click(function(e){
                e.preventDefault();
                e.stopPropagation();
                $(e.target).prop('disabled', true);
                var formData = form.serialize(formNode);
                var url = formNode.attr('action');
                ajax(url, {
                    formData: formData,
                    onSuccess: function(result) {
                        $(e.target).prop('disabled', false);
                    },
                    onFailure: function(result) {
                        var formParent = formNode.parent();
                        formParent.html(result.body);
                        form.init(formParent.find('form'));
                        self.init(formParent.find('form'));
                        $(e.target).prop('disabled', false);
                    },
                    onError: function(result) {
                        $(e.target).prop('disabled', false);
                    },
                });
            });
        },
    };

    return formManager;
});

